import { render, staticRenderFns } from "./Observations.vue?vue&type=template&id=4d37fbb2"
import script from "./Observations.vue?vue&type=script&lang=js"
export * from "./Observations.vue?vue&type=script&lang=js"
import style0 from "./Observations.vue?vue&type=style&index=0&id=4d37fbb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports